export default function UserSalary({ openModal, salaries, lang }: any) {
  const data = salaries?.[0];

  const formatRupiah = (value: number | string | null) => {
    if (!value) return "-";
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
    }).format(Number(value));
  };

  return (
    <div className="bg-white p-4 rounded-xl border space-y-4">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold">{lang === "id" ? "Gaji" : "Salary"}<span className="text-red-500">*</span></h3>
        <button
          onClick={() => openModal("salary")}
          className="text-primary hover:underline"
        >
          ✎ Edit
        </button>
      </div>

      {salaries.map((exp: any, idx: number) => (
        <div key={idx} className=" space-y-3">
          <div className="flex flex-col md:flex-row justify-between">
            <span className="text-gray-600 font-medium">{lang === "id" ? "Gaji Saat Ini" : "Current Salary"}</span>
            <span className="text-gray-900 font-semibold">
              {formatRupiah(data?.currentSalary)} - {data?.currentSalaryMethod}
            </span>
          </div>

          <div className="flex flex-col md:flex-row justify-between">
            <span className="text-gray-600 font-medium">{lang === "id" ? "Gaji Diharapkan" : "Expected Salary"}</span>
            <span className="text-gray-900 font-semibold">
              {formatRupiah(data?.expectedSalary)} - {data?.expectedSalaryMethod}
            </span>
          </div>
          <div className="flex gap-2 md:gap-0 md:justify-between">
            <span className="text-gray-600 font-medium">{lang === "id" ? "Bisa dinegosiasikan" : "Negotiable"}</span>
            <span className="text-gray-900 font-semibold">
              {data.negotiable ? "✅" : "❌"}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}
